import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { RootComponent } from '../../../services/root-component';
import { BasicProps } from '../types';
import { modePresets } from './model';
import { Mode } from '../enums';

export const Layout = forwardRef<HTMLSpanElement, BasicProps>(
  function Component({ mode = Mode.PRIMARY, ...props }, forwardedRef) {
    return (
      <RootComponent
        {...props}
        Component="span"
        baseClassName={clsx(modePresets[mode])}
        role="status"
        aria-live="polite"
        ref={forwardedRef}
      />
    );
  }
);
